const exporting = `
### Copy, then paste

Every generated document has a Copy to Clipboard button. Paste the text into your EMR or intake system. There is no file to save from CensusZen; the clipboard is the way out.

### The documents

Home health cases produce three documents: Pre-SOC Eligibility Report, RN Pre-Visit Briefing, and Diagnosis Codes. Rehab and LTACH cases produce an HPI and a Diagnosis summary. The first tab is the eligibility report on home health cases and the HPI on rehab and LTACH cases. Clinicians open the RN Pre-Visit Briefing tab from there.

### The provenance footer

Every copy ends with a footer that names the tool, the generation date, the reviewer, and the review date:

AI-assisted draft generated by CensusZen on (date). Reviewed by (name) on (date). Verify against source records before use.

The reviewer is whoever completed the fact review on the case. If no one has, the footer reads Review pending. The same footer appears under each document on screen, and on the copied code list and physician query.

### Out-of-date documents

If a fact changes after the documents were generated, a banner on the Documents step says so. Go back to Review & Approve and click Regenerate Documents.

### Admission status

The Documents step also carries the Admission Status menu, so you can record the outcome without returning to the case list.
`;

export default exporting;
